<template>
	<div class="emoFaceModal" v-if="dialogVisibe">
		 <div class="chat-s-popover" style="top: -258px; left: -186px;" v-clickoutside='closeEmoFace'>
				<div class="chat-s-popover__content">
					<div class="chat-s-tabs" style="width: 412px;">
						<div class="chat-s-tabs-content">
							<div class="chat-s-tabs-content__pane" style="">
								<div index="0" tab="表情">
								   <span :title="item" :data-title="item" class="chat-s-editor__emoji-item" v-for="(item,index) of emoList.data.split(',')" :key="index" @click="getEmoFace(item)">{{item}}</span>
								</div>
							</div>
						</div>
						<div class="chat-s-tabs-nav">
							<div class="chat-s-tabs-nav__item chat-s-tabs-nav__item--active">表情</div>
						</div>
					</div>
				</div>
				<div class="chat-s-popover__arrow"></div>
			</div>
	</div>
</template>
<script>
	import clickoutside from 'element-ui/src/utils/clickoutside'
export default {
	props: {
		value: {
		    type: Boolean,
		    default: false
		},
	},
	directives:{
		clickoutside
	},
	data() {
		return {
            classNames: "emoFace",
			emoList: {
			  "data": "😀,😁,😂,😃,😄,😅,😆,😉,😊,😋,😎,😍,😘,😗,😙,😚,😇,😐,😑,😶,😏,😣,😥,😮,😯,😪,😫,😴,😌,😛,😜,😝,😒,😓,😔,😕,😲,😷,😖,😞,😟,😤,😢,😭,😦,😧,😨,😬,😰,😱,😳,😵,😡,😠,💘,❤,💓,💔,💕,💖,💗,💙,💚,💛,💜,💝,💞,💟,❣,💪,👈,👉,☝,👆,👇,✌,✋,👌,👍,👎,✊,👊,👋,👏,👐,✍,🍇,🍈,🍉,🍊,🍋,🍌,🍍,🍎,🍏,🍐,🍑,🍒,🍓,🍅,🍆,🌽,🍄,🌰,🍞,🍖,🍗,🍔,🍟,🍕,🍳,🍲,🍱,🍘,🍙,🍚,🍛,🍜,🍝,🍠,🍢,🍣,🍤,🍥,🍡,🍦,🍧,🍨,🍩,🍪,🎂,🍰,🍫,🍬,🍭,🍮,🍯,🍼,☕,🍵,🍶,🍷,🍸,🍹,🍺,🍻,🍴,🌹,🍀,🍎,💰,📱,🌙,🍁,🍂,🍃,🌷,💎,🔪,🔫,🏀,⚽,⚡,👄,👍,🔥,🙈,🙉,🙊,🐵,🐒,🐶,🐕,🐩,🐺,🐱,😺,😸,😹,😻,😼,😽,🙀,😿,😾,🐈,🐯,🐅,🐆,🐴,🐎,🐮,🐂,🐃,🐄,🐷,🐖,🐗,🐽,🐏,🐑,🐐,🐪,🐫,🐘,🐭,🐁,🐀,🐹,🐰,🐇,🐻,🐨,🐼,🐾,🐔,🐓,🐣,🐤,🐥,🐦,🐧,🐸,🐊,🐢,🐍,🐲,🐉,🐳,🐋,🐬,🐟,🐠,🐡,🐙,🐚,🐌,🐛,🐜,🐝,🐞,🦋,😈,👿,👹,👺,💀,☠,👻,👽,👾,💣"
			}
		}
	},
	computed: {
		dialogVisibe: {
			get() {
				return this.value
			},
			set(news) {
				this.$emit("input",news);
			}
		}
	},
	methods: {
		getEmoFace(item){
			this.$emit('emoFace',item)
		},
		closeEmoFace(){
			this.$emit("input",false);
		}
	}
}
</script>
<style lang="less" >
    @classNames: emoFace;
	.@{classNames}_list{
		background-color: #f2f2f2;
	}
</style>

<style src="../../css/dy-chat.css" scoped></style>
 